/**
 * Created by Arif Topcu in 2019
 */

import TrackingErrorComplication from './TrackingErrorComplication';

export default TrackingErrorComplication;
